







import { defineComponent } from '@vue/composition-api';
import EduTitle from '@/components/storyblok/EduTitle.vue';

export default defineComponent({
  name: 'TrackInfoHeading',
  props: { blok: { type: Object } },
  components: { EduTitle }
});
